module.exports = __webpack_public_path__ + "static/media/test.5ca44966.jpeg";